/* eslint-disable react/prop-types */
import React from 'react';
import ReactPaginate from 'react-paginate';
import './CustomPagination.css';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function Pagination({ pageCount, onPageChange, forcePage }) {
  return (
    <ReactPaginate
      previousLabel={<ChevronLeftIcon />}
      nextLabel={<ChevronRightIcon />}
      breakLabel="..."
      breakClassName="break-me"
      pageCount={pageCount}
      marginPagesDisplayed={2}
      pageRangeDisplayed={4}
      onPageChange={onPageChange}
      forcePage={forcePage}
      containerClassName="pagination"
      subContainerClassName="pages pagination"
      activeClassName="active"
    />
  );
}

export default Pagination;
